import { render, staticRenderFns } from "./editIntegral.vue?vue&type=template&id=a163c08c"
import script from "./editIntegral.vue?vue&type=script&lang=js"
export * from "./editIntegral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports